import { Link, useParams } from '@tanstack/react-router'
import { useTranslations } from 'use-intl'
import { ArrowRight } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { HighlightText } from '@/components/ui/highlight-text'
import { SplitSection } from '@/components/split-section'
import { Reveal } from '@/components/ui/reveal'

/** Badge word inside the heading — a lightened lavender ramp that stays
    legible with the `text-primary` label on top of the saturated primary
    gradient. */
function TailoredBadge({ children }: { children: React.ReactNode }) {
  return (
    <HighlightText className="bg-app-highlight-light">{children}</HighlightText>
  )
}

export function TailoredSection() {
  const t = useTranslations('home.tailored')
  const { locale } = useParams({ from: '/$locale' })

  return (
    /* One Reveal over the whole band; `reveal={false}` tells SplitSection to
       drop its own image fade + copy cascade so the card animates as one block. */
    <Reveal>
      <SplitSection
        tone="primary"
        imageSide="left"
        reveal={false}
        className="mx-4 my-2 overflow-hidden rounded-3xl md:mx-8 lg:mx-auto lg:h-[400px] lg:max-w-7xl"
        image={{
          src: '/backgrounds/tools-simulation.webp',
          width: 886,
          height: 867,
          className: 'lg:h-full lg:max-w-none lg:self-stretch lg:object-cover',
        }}
        title={
          <>
            {t('titleLead')} <TailoredBadge>{t('titleSolution')}</TailoredBadge>{' '}
            {t('titleMid')} <TailoredBadge>{t('titleNeeds')}</TailoredBadge>
          </>
        }
        description={t('description')}
        actions={
          <Button variant="background" size="lg" asChild>
            <Link to="/$locale/tools/solution-configurator" params={{ locale }}>
              {t('cta')}
              <ArrowRight />
            </Link>
          </Button>
        }
      />
    </Reveal>
  )
}
